export default function NotFound() {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4 bg-gray-50">
        <h1 className="text-6xl md:text-8xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">Page introuvable</h2>
        <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-md">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <a 
          href="/" 
          className="inline-flex items-center px-6 py-3 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-medium transition-colors"
        >
          Retour à l'accueil
        </a>
      </div>
    );
  }